import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Row, Col, Spin } from 'antd';
import PropTypes from 'prop-types';
import { Colors, device } from 'utils';
import { projectsServices } from 'services';
import GoodiesCard from './GoodiesCard';


function Goodies({
  projectId,
  projectStatus,
  setRewardsExist,
  isTicketable,
  setRewardsUpper,
  isPreview,
  previewRewards,
}) {
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSelected, setCurrentSelected] = useState(-1);

  const openCards = useCallback((index) => {
    setCurrentSelected((prev) => (prev === index ? -1 : index));
  }, []);

  useEffect(() => {
    let isMounted = true;

    const applyRewards = (rewardList) => {
      if (!isMounted) return;

      setRewards(rewardList);
      setRewardsUpper(rewardList);
      setRewardsExist(rewardList.length > 0);
      setLoading(false);
    };

    if (Array.isArray(previewRewards)) {
      applyRewards(previewRewards.filter((reward) => !reward?.deleted));

      return () => {
        isMounted = false;
      };
    }

    const fetchRewards = async () => {
      setLoading(true);

      try {
        const response = await projectsServices.getProjectRewards(projectId);
        const rewardList = Array.isArray(response) ? response : [];

        applyRewards(rewardList);
      } catch (error) {
        if (!isMounted) return;

        setRewards([]);
        setRewardsUpper([]);
        setRewardsExist(false);
        console.error('Failed to fetch rewards:', error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchRewards();

    return () => {
      isMounted = false;
    };
  }, [previewRewards, projectId, setRewardsExist, setRewardsUpper]);

  if (loading) {
    return (
      <RewardsSection id="rewards-section">
        <Spin spinning />
      </RewardsSection>
    );
  }

  if (!rewards.length) {
    return <RewardsSection id="rewards-section" />;
  }

  return (
    <GoodiesTabWrapper
      id="rewards-section"
      className={
        projectStatus === 'successful' || projectStatus === 'finished'
          ? 'hidden'
          : ''
      }
    >
      <GoodiesTabContent>
        <GoodiesTopBar>
          <GoodiesTitle>{isTicketable ? 'Tickets' : 'Goodies'}</GoodiesTitle>
          {/*{!isTicketable && (*/}
          {/*  <GoodiesDescription>*/}
          {/*    Erhalte ein Dankeschön oder sieh direkt, welchen Unterschied dein*/}
          {/*    Beitrag macht.*/}
          {/*  </GoodiesDescription>*/}
          {/*)}*/}
        </GoodiesTopBar>

        <Row gutter={[0, 0]}>
          {rewards.map((reward, index) => {
            const isLastOddItem =
              rewards.length % 2 === 1 && index === rewards.length - 1;
            return (
              <Col
                key={reward?.id || reward?._id || index}
                xs={{ span: 24, offset: 0 }}
                sm={{ span: 24, offset: 0 }}
                md={{ span: 12, offset: isLastOddItem ? 6 : 0 }}
                lg={{ span: 12, offset: isLastOddItem ? 6 : 0 }}
                xl={{ span: 12, offset: isLastOddItem ? 6 : 0 }}
                style={{ padding: '10px' }}
              >
                <GoodiesCard
                  projectStatus={projectStatus}
                  reward={reward}
                  open={index === currentSelected}
                  projectId={projectId}
                  isTicketable={isTicketable}
                  isPreview={isPreview}
                  order={index + 1}
                  openCards={openCards}
                />
              </Col>
            );
          })}
        </Row>
      </GoodiesTabContent>
    </GoodiesTabWrapper>
  );
}

Goodies.propTypes = {
  projectId: PropTypes.number.isRequired,
  projectStatus: PropTypes.string,
  setRewardsExist: PropTypes.func.isRequired,
  setRewardsUpper: PropTypes.func.isRequired,
  isTicketable: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool,
  previewRewards: PropTypes.array,
};


const RewardsSection = styled.section`
  text-align: center;
  margin-top: 30px;
`;


const GoodiesTabWrapper = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  gap: 24px;
  &.hidden {
    display: none;
  }
`;

const GoodiesTabContent = styled.div`
  max-width: 764px;
  gap: 24px;
  width: 100%;
`;

const GoodiesTopBar = styled.div`
  gap: 12px;
  
  @media ${device.allMobile} {
    padding: 10px;
  }
`;

const GoodiesTitle = styled.h1`
  font-size: 24px;
  color: #181D27;
  font-weight: 600;

  @media ${device.allMobile} {
    font-size: 20px;
  }
`;

const GoodiesDescription = styled.p`
  font-size: 16px;
  color: #535862;
  font-weight: 400;
  line-height: 24px;
  
  @media ${device.allMobile} {
    font-size: 14px;
    line-height: 20px;
  }

`;

export default Goodies;
